import T from '../i18n/content.js';
import { useT } from '../i18n/LangContext.jsx';

export default function Positioning({ asPage = false }) {
  const t = useT();
  const F = T.firm;

  return (
    <section className={`section positioning ${asPage ? 'positioning--page' : ''}`}>
      <div className="wrap">
        {!asPage && (
          <div className="kicker-row" style={{ marginBottom: 56 }}>
            <span className="label">{t(F.kicker)}</span>
            <span className="bronze-rule" />
          </div>
        )}
        <p className="positioning__lede">
          {t(F.lede)}{' '}
          <em>{t(F.ledeEmphasis.discretion)}</em>,{' '}
          <em>{t(F.ledeEmphasis.precision)}</em>, &amp;{' '}
          <em>{t(F.ledeEmphasis.continuity)}</em>.
        </p>
        <div className="principles">
          {T.principles.map(p => (
            <div className="principle" key={p.num}>
              <div className="principle__num">{p.num}</div>
              <div className="principle__name">{t(p.name)}</div>
              <p className="principle__body">{t(p.body)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
